import classNames from 'classnames'
import { forwardRef, useEffect, useState } from 'react'

import type { ChangeEvent, HTMLProps, ReactElement } from 'react'

import InputWrapper from '../InputWrapper'

import './styles.scss'

const initialHeight = '7.6rem'

export interface Props extends Omit<HTMLProps<HTMLTextAreaElement>, 'size'> {
  className?: string
  label?: string
  labelPosition?: 'top' | 'left'
  name: string
  resizable?: boolean
  size?: Exclude<SIZES, 'large'>
  value?: string
}

const TextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({ className, label, labelPosition, name, resizable, size = 'medium', value, ...props }, ref): ReactElement => {
    /** Local state */

    const [wrapperHeight, setWrapperHeight] = useState(initialHeight)

    const [inputHeight, setInputHeight] = useState('100%')

    /** Handlers */

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
      props.onChange && props.onChange(event)
    }

    /** Effects */

    useEffect(() => {
      if (value === '') {
        setWrapperHeight(initialHeight)
        setInputHeight('100%')
      }
    }, [value])

    /** Render */

    return (
      <InputWrapper
        className={classNames('textarea-component', className, { 'textarea-component--resizable': resizable })}
        disabled={props.disabled}
        label={label}
        labelPosition={labelPosition}
        required={props.required}
        size={size}
        style={{ height: wrapperHeight }}
      >
        <textarea
          {...props}
          className="textarea-input"
          name={name}
          onChange={handleChange}
          ref={ref}
          required={false}
          rows={1}
          style={{ height: inputHeight }}
          value={value}
        />
      </InputWrapper>
    )
  }
)

TextArea.displayName = 'TextArea'

export default TextArea
